module.exports = __webpack_public_path__ + "img/121.6.8aba04be.png";